import Main from './RegulationsMain'
import New from './RegulationsNew'
import Edit from './RegulationsEdit'
import Show from './RegulationsShow'

const Regulations = { Main, New, Edit, Show }

export default Regulations
